"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _actions = require("./actions");

var _constants = require("./constants");

var initialState = (0, _immutable.fromJS)({
  hub: {
    marketingProductLevel: _constants.ProductLevels.NONE,
    marketingTrialProductLevel: _constants.ProductLevels.NONE,
    salesProductLevel: _constants.ProductLevels.NONE
  },
  hubUser: {
    paidSeats: []
  }
});

var _default = (0, _fluxActions.handleActions)((0, _defineProperty2.default)({}, _actions.FetchIrisActionTypes.SUCCESS, function (state, action) {
  return state.mergeDeep((0, _immutable.fromJS)(action.payload.data));
}), initialState);

exports.default = _default;
module.exports = exports.default;